import React from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import HomePageContainer
  from '@fuww/library/src/Articles/Homepage/Container';
import WfbAdsSection
  from '@fuww/library/src/Articles/Sections/WfbAds';
import breakpoints from '@fuww/library/src/Theme/breakpoints';
import Head from '../Head';
import ArticleLayout from '../News/ArticleLayout';
import { useSiteContext } from '../SiteContext';
import InView from '../InView';
import messages from '../../lib/messages.mjs';
import getSearchJsonLdData from '../../lib/getSearchJsonLdData';
import loading from '../../lib/loading';
import WfbAds from '../Company/WfbAds';
import {
  wfbAdsHomePageImageConfigurations,
} from '../../lib/imageConfigurations';

const DynamicCategoryNewsSection = dynamic(() => import(
  '../News/Homepage/CategoryNews'
), {
  ssr: false,
  loading,
});

const Index = () => {
  const intl = useIntl();
  const router = useRouter();
  const { newsboard, jobsComplete } = useSiteContext();

  return (
    <HomePageContainer>
      <Head
        title={intl.formatMessage(messages.indexTitle)}
        description={intl.formatMessage(messages.indexDescription)}
        jsonLdData={getSearchJsonLdData(router, intl)}
      />
      <ArticleLayout
        categorySection={(
          <InView>
            <DynamicCategoryNewsSection />
          </InView>
        )}
        wfbAds={jobsComplete && (
          <WfbAdsSection
            wfbAdsHeader={
              intl.formatMessage(messages['company-profiles.title'])
            }
          >
            <WfbAds
              limit={4}
              gridGap="24px"
              imageConfigurations={wfbAdsHomePageImageConfigurations}
              sizes={`
                (min-width: 1440px) 330px,
                (min-width: ${breakpoints.lg}px) calc(25vw - 40px),
                (min-width: ${breakpoints.md}px) calc(34vw - 27px),
                (min-width: ${breakpoints.xs}px) calc(50vw - 28px),
                calc(100vw - 32px)
              `}
            />
          </WfbAdsSection>
        )}
        showCreatedAt
        expandedSections
        featuredVariables={[
          'FASHIONUNITED_INFO',
        ].includes(newsboard)
          ? {
            featured: null,
          }
          : null}
      />
    </HomePageContainer>
  );
};

export default Index;
